/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ amount: NonNullable<unknown> }} Price_Per_MonthInputs */



/**
* | output |
* | --- |
* | "{amount}/mo" |
*
* @param {Price_Per_MonthInputs} inputs
* @param {{ locale?: "en" | "ru" }} options
* @returns {LocalizedString}
*/
export const price_per_month = /** @type {((inputs: Price_Per_MonthInputs, options?: { locale?: "en" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Per_MonthInputs, { locale?: "en" | "ru" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ru") return /** @type {LocalizedString} */ (`${i?.amount}/мес.`)
	return /** @type {LocalizedString} */ (`${i?.amount}/mo`)
});